import React, { useState, useEffect, } from 'react';
import SegmentedInput from '~/shared/SegmentedInput';
import {
    useSpringBigStore,
    useRequestPin, useTheme,
} from '@springbig/shared';
import { VStack, HStack, Box } from 'native-base';
import { Caption, H1, H4 } from '~/shared/Typography';
import { Button } from '~/shared/Theme';

const PinCodeForm = ({
    onProceed,
    onCancel,
    pinLength = 4,
} : {
    onProceed: (code: string) => void,
    onCancel: () => void,
    pinLength?: number,
}) => {

    // This component is meant to be dropped anywhere around the app, it is not to be used for login
    // onProceed only returns the pin code
    // See apps/web/src/pages/profile/components/ProfileForm.tsx for usage example

    const {
        text,
    } = useTheme();

    const { walletId, phoneNumber } = useSpringBigStore();

    const { mutate: requestPin } = useRequestPin();

    const [isPinRequested, setIsPinRequested] =
        useState<boolean>(false);
    const [countdown, setCountdown] =
        useState<number>(0);

    const onSubmit = (code: { pin: string }): void => {

        onProceed(code.pin);
    };

    const onRequestPin = (): void => {

        requestPin({
            stashboardOrMemberKey: walletId,
            reference: 'member',
            pin_length: pinLength,
        }, {
            onSuccess: () => {

                setIsPinRequested(true);
                setCountdown(30);
            }
        });
    };

    useEffect(() => {
        if (countdown <= 0) {
            return;
        }
        
        const timer = setInterval(() => {
            setCountdown((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [countdown]);

    return (
        <VStack space={2}>
            <H1 text={'loginTemplate.enter_code_title'} />
            <H4 text={'loginTemplate.enter_code_subtitle'} textValues={[pinLength]} />
            <SegmentedInput codeLength={pinLength} onSubmit={onSubmit} error={''} />
            <HStack>
                <Box
                    alignSelf={'center'}
                    h={'1px'}
                    backgroundColor={text}
                    flex={1}
                    flexDir={'row'}
                />
                <Caption
                    text={'loginTemplate.or_separator'}
                    px={4}
                    textAlign={'center'}
                />
                <Box
                    alignSelf={'center'}
                    h={'1px'}
                    backgroundColor={text}
                    flex={1}
                    flexDir={'row'}
                />
            </HStack>
            <Caption
                textAlign={'center'}
                text={isPinRequested ? 'loginTemplate.phone_number_message' : 'loginTemplate.no_phone_number_message'}
                textValues={isPinRequested ? [phoneNumber] : []}
            />
            <Button
                text={
                    countdown > 0
                        ? `Resend Code (${countdown}s)`
                        : 'loginTemplate.resend_code_cta'
                }
                onPress={onRequestPin}
                disabled={countdown > 0}
            />
            <Button variant={'neutral'} text={'general.cancel'} onPress={onCancel} />
        </VStack>
    );
};

export default PinCodeForm;
